import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = { ...Abstrap.propTypes, size: PropTypes.oneOf(['small', 'medium', 'large']) };

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    size: 'small',
};

class Grid extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            size,
        } = this.props;
        return [
            'c-grid', {
                'c-grid--s': size === 'small',
                'c-grid--m': size === 'medium',
                'c-grid--l': size === 'large',
            },
            className,
        ];
    }

}

Grid.propTypes = propTypes;

Grid.defaultProps = defaultProps;

export default Grid;
